<template>
  <div>
    <div class="audio_box_s">
      <div>
        <div class="audiotitlex">
          <div class="img_box">
            <img class="img_box" src="@/assets/icon/yinyue.png" />
          </div>
          <div class="fileName_box">
            {{ fileName }}
          </div>
        </div>
      </div>
      <div class="_box">
        <div class="image_box_row">
          <el-image
            class="read_leftt1_imgx"
            :src="select_index"
            fit="contain"
          ></el-image>
        </div>
      </div>
      <div class="top">
        <audioPlay
          ref="audio"
          :url="goodsFilePath"
          :title="fileName"
        ></audioPlay>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
} from "@/api/special/special";
import { videoPlayer } from "vue-video-player";
import { checkIsBuy } from "@/api/bookstore/bookstore";
import "video.js/dist/video-js.css";
import audioPlay from "@/views/onlineReading/mobileClient/components/audioPlay1.vue";
export default {
  components: {
    videoPlayer,
    audioPlay,
  },
  data() {
    return {
      fileName: "",
      goodsFileId: undefined,
      goodsId: this.$route.query.goodsId, //需要传递的参数
      filesId: "", //需要传递的参数(资源文件id)
      relevanceId: undefined,
      resource: undefined,
      resourceType: undefined,
      teachInstId: undefined,
      goodsFilePath: "", //需要传递的参数(资源文件路径)
      readdefault: 0, //默认阅读第一个
      loading: false,
      play: false,
      setInterval2: undefined,
      TimeParameter: 10, //更新频次-单位分钟
    };
  },
  props: {
    select_index: String,
  },
  created() {},
  destroyed() {
    this.closeTime();
  },
  methods: {
    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;
        this.setInterval2 = setInterval(() => {
          this.updateOcDownloadReading(); //更新阅读时长
        }, this.TimeParameter * 60000);
      });
    },
    closeTime() {
      clearInterval(this.setInterval2);
      this.setInterval2 = null;
    },
    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.filesId,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {});
    },
    tabbook(item) {
      this.$refs.audio.onPlayerEnded();
      this.loading = this.$loading({
        lock: true,
      });
      this.goodsFileId = item.filesId;
      this.fileName = item.sourceName;
      this.filesId = item.filesId;
      selectFileLinkAndReadingLocation({
        goodsFileId: item.filesId, //goodsFileId没有，谢萌说可用filesId
        fileType: item.fileType,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {
        this.loading.close();
        let data = res.data;
        if (data) {
          this.buys(item, data);
        }
      });
    },
    buys(item, data) {
      //判断是否购买该商品
      this.payType = this.$route.query.payType
        ? this.$route.query.payType
        : "goods";
      checkIsBuy({
        relevanceId: this.goodsId,
        type: this.payType,
      }).then((res) => {
        if (data.hasPermission) {
          //有权限
          this.goodsFilePath = data.filePath;
          this.selectTimeParameter(); //获取更新进度和时长的频次   循环调用更新时长和更新进度方法
        } else if (res.data == "1" && item.sourceStatus == "2") {
          this.Trial = true; //试读
          this.goodsFilePath = data.filePath;
        } else {
          //无权限
          this.goodsFilePath = "";
          this.checkIsBuys();
        }
      });
    },

    checkIsBuys() {
      //无权限走购买流程
      this.$alert("该文件需要购买后才能阅读，是否确认购买", "购买", {
        confirmButtonText: "立即购买",
        callback: (action) => {
          if (action === "cancel") {
            return;
          }
          let userId = this.$store.getters.userId;
          if (!userId) {
            this.$store.commit("SET_REDIRECTPARAMS", {
              goodsId: this.$route.query.goodsId,
              relevanceId: this.$route.query.relevanceId,
              resource: this.$route.query.resource,
              resourceType: this.$route.query.resourceType,
            });
            this.$router.push({
              path: "/login",
              query: {
                redirectPath: "/onlineReading",
              },
            });
          } else {
            //判断是否购买该商品
            this.payType = this.$route.query.payType
              ? this.$route.query.payType
              : "goods";
            checkIsBuy({
              relevanceId: this.goodsId,
              type: this.payType,
            }).then((res) => {
              console.log("是否已购买响应", res);
              if (res.data === "2") {
                this.$message.error("数据异常");
                return;
              }
              if (res.data === "1") {
                this.$router.push({
                  path: "/submitOrder/index",
                  query: {
                    id: this.$route.query.goodsId,
                    from: "bookstore",
                  },
                });
              } else {
                this.$message("该商品已购买无需重复购买");
              }
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.audio_box_s {
  float: left;
  width: calc(100% - 340px);
  min-height: 95vh;
  position: relative;
  background: #fff;
}

.audio_box {
  width: 1400px;
  margin: 0 auto;
}

.audio_con {
  width: calc(100% - 700px);
  margin: 30px auto;
  background: #fff;
}

.audio_con .video-player {
  height: 30px;
  position: relative;
  padding: 0;
}

.audio_con ::v-deep .video-js {
  height: 30px;
  padding: 0;
}

.audio_con .vjs-tech {
  height: 30px;
  padding: 0;
}

.audio_con ::v-deep .video-js .vjs-tech {
  display: none;
}

.audio_con .vjs-control-bar {
  height: 30px;
  padding: 0;
  position: absolute;
  left: 0;
  bottom: 0;
}

.audio_con ::v-deep .vjs-control-bar {
  opacity: 1 !important;
  display: flex !important;
}

.audio_con ::v-deep .vjs-big-play-button {
  display: none;
}

/* .audio_con::v-deep.vjs-play-control {
		display: none;
	} */

.read_leftt1_img {
  float: left;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  border: 1px solid #f2f2f2;
  background: #fff;
}
.audiotitle {
  margin-top: 10px;
  text-align: center;
}

.audio_box_l {
  position: relative;
}

.audio_box_l_ico {
  position: absolute;
  left: 27px;
  top: 27px;
  z-index: 10;
  color: #ddd;
  font-size: 30px;
  cursor: pointer;
}

.audio_box_l_ico2 {
  position: absolute;
  left: 27px;
  top: 27px;
  z-index: 10;
  color: #ddd;
  font-size: 30px;
  cursor: pointer;
}

.close_ico {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  cursor: pointer;
}
.img_box {
  width: 20px;
  height: 20px;
  background: #666666;
}
.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}
.read_leftt1_imgx {
  width: 200px;
  margin: 0 auto;
}
.image_box_row {
  width: 200px;
  margin: 200px auto 0 auto;
}
.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
._box {
  width: 100%;
  margin: 0 auto;
}
.top {
  margin-top: 30px;
}
</style>
